module.exports = __webpack_public_path__ + "img/col1-thumbnail.d53f782b.webp";